// src/hooks/useProductPageContent.js
import { useState } from "react";
import { getCompanyList } from "../services/shopUserService";

const useCompanyList = () => {
  const [status, setStatus] = useState("idle"); // idle | loading | done | error
  const [error, setError] = useState("");
  const [data, setData] = useState([]);
  const [total, setTotal] = useState(0);

  const fetchCompanyList = async (req) => {
    setStatus("loading");
    setError("");

    try {
      const response = await getCompanyList(req);

      if (response?.status !== "Error") {
        setData(response.data ?? response); // depending on API shape
        setTotal(response.total ?? 0); // assuming total is part of the response
        setStatus("done");
      } else {
        setStatus("error");
        setError(response?.message || "Something went wrong");
      }
    } catch (err) {
      setStatus("error");
      setError(err?.message || "Something went wrong");
    }
  };

  const resetStatus = () => {
    setStatus("idle");
    setError("");
  };

  return {
    fetchCompanyList,
    data,
    total,
    status,
    error,
    resetStatus,
  };
};

export default useCompanyList;
